import { X } from "lucide-react";
import { useImpersonation } from "../context/ImpersonationContext";

const ImpersonationBanner = () => {
  const { impersonating, setImpersonating } = useImpersonation();

  if (!impersonating) return null;

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium z-50">
      <span>
        Viewing as <strong>{impersonating}</strong>
      </span>
      <button
        onClick={() => setImpersonating(null)}
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-amber-600 hover:bg-amber-700 transition-colors text-white text-xs"
      >
        <X className="w-3 h-3" />
        Stop
      </button>
    </div>
  );
};

export default ImpersonationBanner;
